import React from 'react'
import { __RouterContext } from 'react-router'

/**
 * Hook providing the same props than the original withRouter HOC
 * @see https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/withRouter.md
 */
export default function useRouter() {
  return React.useContext(__RouterContext)
}
